const ink = "#0E3A2A";
const inkMuted = "#6B7770";
const inkFaint = "#98A39C";
const hairline = "#E5DCC8";
const hairlineStrong = "#D8CCB2";

const styles = {
  card: {
    width: "100%",
    background: "linear-gradient(180deg, #F3F7F4 0%, #FFFFFF 55%)",
    borderRadius: "20px",
    border: `1px solid ${hairlineStrong}`,
    p: "22px 22px 20px",
    mb: 1,
    color: ink,
  },
  iconBox: {
    backgroundColor: ink,
    color: "#fff",
  },
  badge: {
    backgroundColor: ink,
    color: "#fff",
  },
  subStrong: {
    color: ink,
    fontWeight: 600,
  },
  progressBar: {
    height: 6,
    backgroundColor: hairline,
    borderRadius: "999px",
    overflow: "hidden",
    m: "16px 0 4px",
  },
  progressFill: (percent: number) => ({
    height: "100%",
    width: `${percent}%`,
    backgroundColor: ink,
    borderRadius: "999px",
    transition: "width .35s",
  }),
  steps: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    m: "16px 0 20px",
  },
  step: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    padding: "7px 12px",
    borderRadius: "999px",
    backgroundColor: "#fff",
    border: `1px solid ${hairlineStrong}`,
    fontSize: 13,
    fontWeight: 600,
    color: ink,
  },
  stepTime: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    fontSize: "11.5px",
    fontWeight: 500,
    color: inkMuted,
    "& svg": { color: inkFaint },
  },
  cta: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    alignSelf: "flex-start",
    mt: "auto",
    backgroundColor: ink,
    color: "#fff",
    padding: "11px 18px",
    borderRadius: "999px",
    fontWeight: 600,
    fontSize: "13.5px",
    fontFamily: "inherit",
    border: "none",
    cursor: "pointer",
    minHeight: 41,
    "&:hover": { backgroundColor: "#07271c" },
    "&:disabled": { cursor: "default", opacity: 0.85 },
  },
};

export default styles;
